import { GridButton } from '@eforall/dashboard';
import { VolunteeringProspectsService } from '../../../volunteering-prospects.service';


export function getButtons(service: VolunteeringProspectsService) {

	const buttons: GridButton[] = [
		{
			iconClass: 'fa-refresh',
			label: 'Refresh',
			execute: async () => { await service.getAllClosedVolunteers(); }
		},
	];

	return buttons;
}